import { useEffect, useState } from "react";
import button from "../../../../assets/landingPage/button.svg"
import { VslPricingData } from "../../../../constant/Data";

function PricingCard({ plan, isMiddle, isThird, vid }) {
    const [isOpenModal, setIsOpenModal] = useState(false);
    const SECONDS_TO_DISPLAY = 10;

    return (
        <div
            className={`relative bg-[#F7F6F4] rounded-lg shadow-lg  h-fit
            ${isMiddle ? "order-1 lg:order-none lg:-mt-8 lg:-mb-8" : ""}
            ${isThird ? "order-2 lg:order-none lg:-mt-3" : ""}
            ${!isMiddle && !isThird ? "order-3 lg:order-none lg:-mt-3" : ""}
        `}
        >
            {/* Best Value Badge */}
            {plan.bestValue && (
                <div className="relative">
                    <div className="ribbon-left">
                        <p>
                            <span>Best Value</span>
                        </p>
                    </div>
                </div>
            )}


            {/* Header */}
            <div
                className={`text-center rounded-t-lg space-y-3 pt-7 pb-4 ${plan.bestValue
                    ? "bg-gradient-to-b from-[rgba(244,224,169,0)] via-[#eccc75] to-[#ebbf4f]"
                    : "bg-[#85ade1]"
                    }`}
            >
                <h3 className="text-[48px] fon leading-none  text-[#132c4d] uppercase font-black ">
                    {plan.title}
                    <br />
                </h3>

                <p className="text-[30px] font-semibold text-black leading-[45px]">
                    {plan.subtitle}
                </p>
            </div>


            {/* Content */}
            <div
                className={`space-y-1 relative rounded-md ${plan.bestValue
                    ? "bg-[#f0ddca] px-6 pt-10 "
                    : "bg-[#F7F6F4] px-6 pt-8"
                    }`}
            >
                <div>
                    <img
                        src={plan.product}
                        alt={`${plan.title} Package`}
                        className={`${plan.popular
                            ? "lg:w-[330px] w-full h-auto"
                            : plan.leastpopular
                                ? "lg:w-80  w-full h-auto"
                                : "lg:w-80 w-full h-auto"
                            }  mx-auto hover:opacity-90 ease-in-out duration-300 transition   `}
                    />
                </div>


                {/* Pricing */}
                <div className="text-center space-y-4">
                    <div className="flex items-baseline justify-center gap-1">
                        <span className="text-[55px] font-black">
                            ${plan.pricePerBottle}
                        </span>
                        <span className="text-gray-800 font-semibold text-2xl">
                            /bottle
                        </span>
                    </div>
                    {/* Features */}

                    <div className="space-y-1">
                        {plan.shippingfee && (
                            <div className="p-4 py-8  text-[#281c1780]">
                                <p className="lg:text-xl xl:text-2xl text-xl font-bold uppercase">
                                    {plan.shippingfee}
                                </p>
                            </div>
                        )}
                        {plan.youSave && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#204058] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.youSave}
                                </p>
                            </div>
                        )}
                        {plan.discount && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#DE3C3E] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.discount}
                                </p>
                            </div>
                        )}

                        {plan.freeshipping && plan.popular && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#146E54] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.freeshipping}
                                </p>
                            </div>
                        )}
                        {plan.freeshipping && !plan.popular && (
                            <div className="px-4 py-2 lg:mb-16 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#146E54] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.freeshipping}
                                </p>
                            </div>
                        )}

                        {plan.bonuses && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#0A203C] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.bonuses}
                                </p>
                            </div>
                        )}
                        {plan.gurantee && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#0090E1] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.gurantee}
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Order Button */}
                {/* <div className=" flex items-center justify-center text-center text-xs">
                    <a href={plan.buttonlink}>
                        <img src={button} />
                    </a>
                </div> */}

                <div className=" flex items-center justify-center text-center text-xs">
                    <a
                        id="cta-button"
                        href={`${plan.url}${vid ? `&vtid=${vid}` : ""}`} // Add the href here
                        onClick={(e) => {
                            const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
                            const alreadyElsDisplayed = localStorage.getItem(alreadyDisplayedKey);

                            if (alreadyElsDisplayed) {
                                localStorage.removeItem(alreadyDisplayedKey);
                            }

                            const url = `${plan.url}${vid ? `&vtid=${vid}` : ""}`;
                            console.log(url);
                        }}
                    >
                        <span className="cursor-pointer">
                            <img src={button} alt="CTA Button" />
                        </span>
                    </a>



                </div>
                {/* Payment Methods */}
                <div className="flex items-center justify-center gap-2 bg-white rounded-md px-4 py-2 shadow-md w-fit mx-auto ">
                    <div className="flex items-center justify-center gap-5">
                        <img src="https://cdn1.breatheagain.io/media/vsl/paymentmethod.webp" />
                    </div>
                </div>

                {/* Pricing */}
                <div className="block text-center mt-6 pb-2">
                    <span className="line-through text-[#132c4d] decoration-red-600 font-semibold text-[26px]">
                        {" "}
                        ${plan.originalPrice}
                    </span>

                    {plan.leastpopular && (
                        <span className="text-[#132c4d] font-extrabold text-[29px] pl-3">
                            ${plan.discountedPrice} + S&amp;H
                        </span>
                    )}

                    {!plan.leastpopular && (
                        <span className="text-[#132c4d] font-extrabold text-[29px] pl-3">
                            ${plan.discountedPrice}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}

const PricingCards = ({ heading, startTimer }) => {
    const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
    const [vid, setVid] = useState("");

    useEffect(() => {
        if (window?.clickmagick_cmc?.vid) {
          setVid(window.clickmagick_cmc.vid);
        }
      }, []);

    useEffect(() => {
        if (!startTimer) return;

        const timerInterval = setInterval(() => {
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(timerInterval); // Cleanup
    }, [startTimer]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
            2,
            "0"
        )}`;
    };
    return (
        <>
            <div className="bg-[#204058] py-10">

                <div className="p-6 border-8 border-white w-fit mx-auto mb-5 relative">
                    <h2 className="md:text-4xl md:!leading-[45px] leading-7 font-bold sm:text-xl text-lg text-white text-center">
                        Stock Up On Lung Renew Today Before
                        <br /> The Next Supply Chain Breakdown:
                    </h2>
                    <div className="absolute left-[38%] md:left-[40%] p-5 pt-2 bg-[#204058] ">
                        <strong className="text-[#95cff6] text-2xl">
                            {formatTime(timeLeft)}
                        </strong>
                    </div>
                </div>

                <div className="mx-auto md:px-6 px-4 py-8 max-w-7xl md:mt-10">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                        {VslPricingData.map((plan, index) => (
                            <PricingCard
                                key={index}
                                plan={plan}
                                isMiddle={index === 1}
                                isThird={index === 2}
                                vid={vid} // 👈 Pass vid to PricingCard

                            />
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PricingCards;